import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { ROUTE } from 'utils/constants';
import { STEPS_WITH_PATH } from 'utils/stepsConstants';
import { isDatadogRumInitialized } from 'utils/initDatadogRum';

type RumRouteConfig = {
  exact: boolean;
  name: string;
  path: string;
};

const stepRouteViewConfigs: RumRouteConfig[] = STEPS_WITH_PATH.map((step) => {
  const path = step.PATH;
  const name = step.ID || step.name || path;

  if (!path || !name) {
    return null;
  }

  return {
    exact: true,
    name,
    path,
  };
}).filter((route): route is RumRouteConfig => route !== null);

const rumRouteViewConfigs: RumRouteConfig[] = [
  ...stepRouteViewConfigs,
  {
    exact: true,
    name: 'MORE_INFORMATION',
    path: ROUTE.MORE_INFORMATION,
  },
  {
    exact: true,
    name: 'REDIRECT_PAGE',
    path: `${ROUTE.REDIRECT_PAGE}/:variant`,
  },
  {
    exact: false,
    name: 'STEPPER_MANAGER',
    path: ROUTE.STEPPER_MANAGER,
  },
  {
    exact: true,
    name: 'CLIENT_REDIRECT',
    path: ROUTE.CLIENT_REDIRECT,
  },
];

export const getDatadogRumViewName = (pathname: string): string => {
  const matchedRoute = rumRouteViewConfigs.find((route) =>
    matchPath(pathname, {
      exact: route.exact,
      path: route.path,
      strict: false,
    }),
  );

  return matchedRoute?.name || pathname || 'UNKNOWN_VIEW';
};

const DatadogRumViewTracking = (): null => {
  const location = useLocation();

  useEffect(() => {
    if (!isDatadogRumInitialized()) {
      return;
    }

    datadogRum.startView({
      name: getDatadogRumViewName(location.pathname),
    });
  }, [location.pathname]);

  return null;
};

export default DatadogRumViewTracking;
